import { render, staticRenderFns } from "./egames.vue?vue&type=template&id=386e9bd0&lang=pug&"
import script from "./egames.vue?vue&type=script&lang=js&"
export * from "./egames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports